// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.input-bank input[data-v-ada19f58] {\n  background-color: #F9F9FA;\n  padding: 15px;\n  font-size: 14px;\n  width: 100%;\n  border-radius: 8px;\n  -ms-flex-preferred-size: calc(100% - 190px);\n      flex-basis: calc(100% - 190px);\n}\n.input-bank--error input[data-v-ada19f58] {\n  background-color: rgb(255, 147, 169);\n}\n.input-bank__error[data-v-ada19f58] {\n  color: rgb(255, 147, 169);\n  margin-top: 5px;\n  font-size: 12px;\n}\n", ""]);
// Exports
module.exports = exports;
